<template lang="html">

  <section  v-bind:class="this.token == null ? 'fullContentPage' : ''" class="main-view">
    <div class="container-scroller">
      <router-view name="appHeader"></router-view>
      <div class="container-fluid page-body-wrapper">
        <router-view name="appSidebar"></router-view>
        <div class="main-panel">
          <div class="content-wrapper">
            <router-view name='appContent'></router-view>
          </div>
          <!-- content wrapper ends -->
          <router-view name="appFooter"></router-view>
        </div>
        <!-- main panel ends -->
      </div>
      <!-- page-body-wrapper ends -->
      <div style="display: none; position: fixed;bottom: 10px;
      right: 10px;background-color: #9386ff;padding: 25px;border-radius: 5px;color: #fff;font-size: .90em;
">MENSAGEM DE ALERTA AQUI</div>
    </div>
  </section>

</template>

<script lang="js">
import { getCookie } from '@/helpers/cookie'
import menuStore from '@/store/menuStore'

function readStoredUser () {
  const raw = localStorage.getItem('user')
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export default {
  name: 'MainPage',
  data () {
    return {
      user: readStoredUser(),
      token: null
    }
  },
  async beforeMount () {
    await this.syncSession()
  },
  watch: {
    async '$route' () {
      this.action = this.$route.params.action
      await this.syncSession()
      if (
        this.$route.meta.roles &&
        this.user &&
        this.user.roles &&
        this.user.roles[0] &&
        !this.$route.meta.roles.includes(this.user.roles[0].name)
      ) {
        this.$router.push({ path: '/nao-autorizado' })
      }
    }
  },
  methods: {
    async syncSession () {
      const previousToken = this.token
      const previousTenantId = this.user && this.user.tenantId
      this.token = getCookie('token')
      this.user = readStoredUser()

      const isLoggedIn = this.token && this.user
      const becameLoggedIn = isLoggedIn && !previousToken
      const tenantChanged = isLoggedIn &&
        previousTenantId &&
        this.user.tenantId &&
        previousTenantId !== this.user.tenantId

      if (becameLoggedIn || tenantChanged) {
        try {
          await menuStore.actions.fetchMenus()
        } catch (error) {
          console.error('Erro ao carregar menus:', error)
        }
      } else if (!isLoggedIn) {
        menuStore.mutations.SET_MENUS([])
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .main-view {

  }
  .fullContentPage {
    .main-panel{
      width: 100%;
      .content-wrapper {
        padding: 0!important;
        .page-body-wrapper {
          min-height: 0!important;
        }
      }
    }
    .container-scroller{
      .page-body-wrapper.full-page-wrapper {
        min-height: calc(100vh - 80px)!important;
      }
    }
    .navbar.fixed-top + .page-body-wrapper {
      padding-top: 10;
    }
  }
</style>



// WEBPACK FOOTER //
// src/mainView.vue